import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { deactivateAudioGraph } from '../helpers/deactivate-audio-graph';
import { isValidLatencyHint } from '../helpers/is-valid-latency-hint';
export var createAudioContextConstructor = function createAudioContextConstructor(baseAudioContextConstructor, createInvalidStateError, createNotSupportedError, createUnknownError, mediaElementAudioSourceNodeConstructor, mediaStreamAudioDestinationNodeConstructor, mediaStreamAudioSourceNodeConstructor, mediaStreamTrackAudioSourceNodeConstructor, nativeAudioContextConstructor) {
  return /*#__PURE__*/function (_baseAudioContextCons) {
    _inherits(AudioContext, _baseAudioContextCons);

    var _super = _createSuper(AudioContext);

    function AudioContext() {
      var _this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, AudioContext);

      if (nativeAudioContextConstructor === null) {
        throw new Error('Missing the native AudioContext constructor.');
      }

      var nativeAudioContext;

      try {
        nativeAudioContext = new nativeAudioContextConstructor(options);
      } catch (err) {
        // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
        if (err.code === 12 && err.message === 'sampleRate is not in range') {
          throw createNotSupportedError();
        }

        throw err;
      } // Bug #131 Safari returns null when there are four other AudioContexts running already.


      if (nativeAudioContext === null) {
        throw createUnknownError();
      } // Bug #51 Only Chrome, Edge and Opera throw an error if the given latencyHint is invalid.


      if (!isValidLatencyHint(options.latencyHint)) {
        throw new TypeError("The provided value '".concat(options.latencyHint, "' is not a valid enum value of type AudioContextLatencyCategory."));
      } // Bug #150 Safari does not support setting the sampleRate.


      if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) {
        throw createNotSupportedError();
      }

      _this = _super.call(this, nativeAudioContext, 2);
      var latencyHint = options.latencyHint;
      var _nativeAudioContext = nativeAudioContext,
          sampleRate = _nativeAudioContext.sampleRate; // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.

      _this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate :
      /*
       * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
       * ScriptProcessorNode.
       */
      Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
      _this._nativeAudioContext = nativeAudioContext; // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.

      if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
        _this._nativeGainNode = nativeAudioContext.createGain();
        _this._nativeOscillatorNode = nativeAudioContext.createOscillator();
        _this._nativeGainNode.gain.value = 1e-37;

        _this._nativeOscillatorNode.connect(_this._nativeGainNode).connect(nativeAudioContext.destination);

        _this._nativeOscillatorNode.start();
      } else {
        _this._nativeGainNode = null;
        _this._nativeOscillatorNode = null;
      }

      _this._state = null;
      /*
       * Bug #34: Chrome, Edge and Opera pretend to be running right away, but fire an onstatechange event when the state actually
       * changes to 'running'.
       */

      if (nativeAudioContext.state === 'running') {
        _this._state = 'suspended';

        var revokeState = function revokeState() {
          if (_this._state === 'suspended') {
            _this._state = null;
          }

          nativeAudioContext.removeEventListener('statechange', revokeState);
        };

        nativeAudioContext.addEventListener('statechange', revokeState);
      }

      return _this;
    }

    _createClass(AudioContext, [{
      key: "baseLatency",
      get: function get() {
        return this._baseLatency;
      }
    }, {
      key: "state",
      get: function get() {
        return this._state !== null ? this._state : this._nativeAudioContext.state;
      }
    }, {
      key: "close",
      value: function close() {
        var _this2 = this;

        // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
        if (this.state === 'closed') {
          return this._nativeAudioContext.close().then(function () {
            throw createInvalidStateError();
          });
        } // Bug #34: If the state was set to suspended before it should be revoked now.


        if (this._state === 'suspended') {
          this._state = null;
        }

        return this._nativeAudioContext.close().then(function () {
          if (_this2._nativeGainNode !== null && _this2._nativeOscillatorNode !== null) {
            _this2._nativeOscillatorNode.stop();

            _this2._nativeGainNode.disconnect();

            _this2._nativeOscillatorNode.disconnect();
          }

          deactivateAudioGraph(_this2);
        });
      }
    }, {
      key: "createMediaElementSource",
      value: function createMediaElementSource(mediaElement) {
        return new mediaElementAudioSourceNodeConstructor(this, {
          mediaElement: mediaElement
        });
      }
    }, {
      key: "createMediaStreamDestination",
      value: function createMediaStreamDestination() {
        return new mediaStreamAudioDestinationNodeConstructor(this);
      }
    }, {
      key: "createMediaStreamSource",
      value: function createMediaStreamSource(mediaStream) {
        return new mediaStreamAudioSourceNodeConstructor(this, {
          mediaStream: mediaStream
        });
      }
    }, {
      key: "createMediaStreamTrackSource",
      value: function createMediaStreamTrackSource(mediaStreamTrack) {
        return new mediaStreamTrackAudioSourceNodeConstructor(this, {
          mediaStreamTrack: mediaStreamTrack
        });
      }
    }, {
      key: "resume",
      value: function resume() {
        var _this3 = this;

        if (this._state === 'suspended') {
          return new Promise(function (resolve, reject) {
            var resolvePromise = function resolvePromise() {
              _this3._nativeAudioContext.removeEventListener('statechange', resolvePromise);

              if (_this3._nativeAudioContext.state === 'running') {
                resolve();
              } else {
                _this3.resume().then(resolve, reject);
              }
            };

            _this3._nativeAudioContext.addEventListener('statechange', resolvePromise);
          });
        }

        return this._nativeAudioContext.resume().catch(function (err) {
          // Bug #55: Chrome, Edge and Opera do throw an InvalidAccessError instead of an InvalidStateError.
          // Bug #56: Safari invokes the catch handler but without an error.
          if (err === undefined || err.code === 15) {
            throw createInvalidStateError();
          }

          throw err;
        });
      }
    }, {
      key: "suspend",
      value: function suspend() {
        return this._nativeAudioContext.suspend().catch(function (err) {
          // Bug #56: Safari invokes the catch handler but without an error.
          if (err === undefined) {
            throw createInvalidStateError();
          }

          throw err;
        });
      }
    }]);

    return AudioContext;
  }(baseAudioContextConstructor);
};